module.exports = __webpack_public_path__ + "img/laptop-fill.e29abd33.svg";